
import { useIntl } from 'react-intl';

export const useInternationalizedOptions = options => {

    const intlApi = useIntl();

    if(Array.isArray(options)) {
        return options.map(option => ({
            ...option,
            text: intlApi.formatMessage({ id: option.text })
        }));
    }

    if(typeof options === 'object') {
        Object.keys(options).forEach(key => {
            options[key] = intlApi.formatMessage({ id: options[key] });
        });
        return options;
    }
};